import { getBrowserIcon } from '@hotjar/webapp/utils/icons';
import { Icon, Tooltip } from '@hotjar/hotsauce';
import { useBrowserName } from '@hotjar/feedback';

export function BrowserDetails({ browser }: { browser: string }): JSX.Element {
  const browserText = useBrowserName(browser);
  return (
    <Tooltip text={browserText}>
      <Icon description={browserText} icon={getBrowserIcon(browser)} />
    </Tooltip>
  );
}
